var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"value":_vm.value,"label":_vm.label,"color":"secondary","type":"number","outlined":"","dense":"","clearable":"","success":_vm.success,"error-messages":_vm.error},on:{"focus":function($event){_vm.error = ''},"blur":_vm.validate,"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }